<template>
  <v-row justify="center" v-if="haveQuestion">
    <v-dialog v-model="haveQuestion" persistent max-width="579px">
      <v-card>
        <v-card-title class="title-dialog">
          <span class="question-title">Question</span>
          <v-btn icon @click="submitQuestion('cancel')" class="close-dialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <!-- <v-card-text style="height: 300px;"> -->
        <!-- <v-card-text class="pr-5 pl-5"> -->
        <div class="question-container">
          <div v-if="questionDetail.imageQuestion !== ''" class="question-img">
            <v-img
              :src="questionDetail.imageQuestion"
              :lazy-src="questionDetail.imageQuestion"
            ></v-img>
          </div>
          <!-- <div class="question-img"><v-img src="https://s3.deknerd.com/api/v1.0/image/banner/358b21a3-1ce2-4f1c-b306-73a47f807fe7.png" :lazy-src="question.imageQuestion"></v-img></div> -->
          <div class="question">{{ questionDetail.question }}</div>
          <div class="or-line text-center">
            <span>Answer Options</span>
          </div>
          <!-- <v-radio-group v-model="dialogm1" column>
              <v-radio class="choice-answer" label="Bahamas, The" value="bahamas"></v-radio>
              <v-radio class="choice-answer" label="Bahrain" value="bahrain"></v-radio>
              <v-radio class="choice-answer" label="Bangladesh" value="bangladesh"></v-radio>
              <v-radio class="choice-answer" label="Barbados" value="barbados"></v-radio>
          </v-radio-group>-->
          <div
            class="choice-answer"
            :class="{ select: selectAnswerID == choice._id }"
            v-for="(choice, index) in questionDetail.choices"
            :key="index"
            @click="selectAnswer(choice._id)"
          >
            <div class="choice_btn_container">
              <v-icon class="icon-choice" v-if="selectAnswerID !== choice._id"
                >far fa-circle</v-icon
              >
              <v-icon class="icon-choice" color="#E77B9F" v-else
                >far fa-check-circle</v-icon
              >
            </div>
            <div class="choice_answer_container">
              <span
                class="choice-text"
                v-if="choice.text !== null && choice.text !== ''"
                >{{ choice.text }}</span
              >
              <!-- <v-img class="choice-img" v-if="choice.image!==null" :src="choice.image" :lazy-src="choice.image"></v-img> -->
              <img
                class="choice-img"
                v-if="choice.image !== null && choice.image !== ''"
                :src="choice.image"
                :lazy-src="choice.image"
              />
            </div>
          </div>
        </div>
        <!-- </v-card-text> -->
        <v-divider></v-divider>
        <!-- <div class="question-container"> -->
        <v-card-actions class="question-container">
          <div class="countdown">Time remaining {{ time }} seconds</div>
          <v-spacer></v-spacer>
          <v-btn
            color="#D9D9D9"
            class="btn-close"
            elevation="0"
            outlined
            @click="submitQuestion('cancel')"
            >Close</v-btn
          >
          <v-btn
            :color="$buttonColor"
            elevation="0"
            dark
            @click="submitQuestion('answer')"
            v-if="selectAnswerID !== null"
            >Send</v-btn
          >
          <v-btn
            :color="$buttonColor"
            elevation="0"
            v-if="selectAnswerID === null"
            disabled
            >Send</v-btn
          >
        </v-card-actions>
        <!-- </div> -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogWarning" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          ไม่สามารถตอบคำถามได้
        </v-card-title>

        <v-card-text>
          ท่านได้ตอบคำถามข้อนี้แล้ว
          กรุณาตรวจสอบการเข้าสู่ระบบจากอุปกรณ์อื่นของท่าน
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialogNotReply">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogWarning2" persistent width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          คุณไม่ต้องการตอบคำถามข้อนี้ใช่หรือไม่
        </v-card-title>

        <v-card-text> หากยืนยันแล้วจะไม่สามารถตอบคำถามข้อนี้ได้ </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="dialogWarning2 = false">
            ยกเลิก
          </v-btn>
          <v-btn color="primary" text @click="closeDialogAll"> ยืนยัน </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogm1: "",
      dialog: false,
      // question: "",
      questionDetail: {},
      selectAnswerID: null,
      time: 0,
      haveQuestion: false,
      dialogWarning: false,
      dialogWarning2: false,
      countdown: null,
    };
  },
  computed: mapState(["liveQuestion", "question", "sendQuizError"]),
  watch: {
    async sendQuizError(value) {
      if (value != null) {
        this.dialogWarning = true;
      }
    },
    async liveQuestion(value) {
      if (value !== null) {
        if (this.countdown) {
          clearInterval(this.countdown);
          this.selectAnswerID = null;
        }
        // console.log(this.$store.getters.setServerDiffTime);
        // let questionCheck = localStorage.getItem("questionCheck");
        // if (questionCheck) {
        //   questionCheck = JSON.parse(questionCheck);
        // } else {
        //   questionCheck = {};
        // }
        const timeLeft = this.$store.getters.dialogCountdownTime(value);
        // console.log(questionCheck[value.questionID], value.timeRequest);
        if (timeLeft > 2000) {
          this.$store.dispatch("fetchQuestion", { idquiz: value.questionID });
          // setTimeout(async () => {
          //   await this.submitQuestion("ignore");
          //   await this.closeDialog();
          //   clearInterval(this.minusTime);
          // }, timeLeft);
          this.time = Math.floor(timeLeft / 1000);
          this.countdown = setInterval(async () => {
            this.time -= 1;
            if (this.time === 0) {
              await this.submitQuestion("ignore");
              await this.closeDialog();
            }
          }, 1000);
        }
      } else {
        this.haveQuestion = false;
      }
    },
    question(value) {
      if (value) {
        this.haveQuestion = true;
        this.dialogWarning = false;
      }
      this.questionDetail = value;
    },
  },
  methods: {
    selectAnswer(id) {
      this.selectAnswerID = id;
    },
    closeDialog() {
      clearInterval(this.countdown);
      this.selectAnswerID = null;
      this.$store.commit("updateLiveQuestion", null);
    },
    closeDialogAll() {
      this.dialogWarning2 = false;
      this.haveQuestion = false;
    },
    closeDialogNotReply() {
      this.dialogWarning = false;
      this.haveQuestion = false;
      this.$store.commit("closeLiveQuestion", null);
    },
    async submitQuestion(event) {
      if (this.countdown) {
        clearInterval(this.countdown);
      }
      if (event == "answer") {
        let payload = {
          idquiz: this.liveQuestion.questionID,
          answer: this.selectAnswerID,
          event: event,
          messageKey: this.liveQuestion.messageKey,
        };
        this.$store.dispatch("sendAnswer", payload);
      } else {
        this.dialogWarning2 = true;
      }

      // let questionCheck = localStorage.getItem("questionCheck");
      // console.log(this.liveQuestion);
      // let item = {};
      // item[this.liveQuestion.questionID] = this.liveQuestion.timeRequest;
      // debugger;
      // if (questionCheck) {
      //   questionCheck = JSON.parse(questionCheck);
      //   item = { ...questionCheck, ...item };
      // }
      // localStorage.setItem("questionCheck", JSON.stringify(item));
      // console.log(this.liveQuestion.questionID);
    },

    minusTime() {
      if (this.time) {
        this.time -= 1;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.or-line {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
  line-height: 0.1em;
  margin: 24px auto 20px;
}
.or-line span {
  background: #fff;
  padding: 0 10px;
  color: #000000;
  font-weight: 400;
  font-size: 15px;
}
@media only screen and (max-width: 768px) {
  .or-line {
    width: 100%;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .or-line {
    width: 100%;
  }
}
.question-container {
  padding: 24px;
}
.question {
  font-size: 15px;
  line-height: 1.733;
  font-weight: 400;
}
.choice-answer {
  padding: 22px;
  margin-bottom: 24px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: -webkit-flex;
  .choice-text {
    word-break: break-all;
    font-size: 15px;
    font-weight: 400;
  }
  .icon-choice {
    color: #d8d8d8;
    padding-right: 19px;
  }
}
.choice-answer.select {
  border: 1px solid #e77b9f;
}
.btn-close {
  color: #000000;
  font-size: 14px;
}
.countdown {
  font-weight: 400;
  font-size: 14px;
  color: #4a4a4a;
}
.title-dialog {
  display: flow-root;
}
.question-img {
  margin-bottom: 16px;
}
.question-title {
  float: left;
  font-size: 16px !important;
  font-weight: 400 !important;
  color: #000000 !important;
}
.close-dialog {
  float: right;
}
.choice-img {
  display: inline-block;
  max-width: 100%;
}
.choice_btn_container {
  width: 43px;
  max-width: 100%;
}
.choice_answer_container {
  clear: left;
  width: 100%;
}
// .v-dialog:not(.v-dialog--fullscreen){
//   max-height: unset;
// }
</style>

